export default __webpack_public_path__ + "static/media/school_icon.70d18f09.svg";